import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-popup',
  imports: [
    NgIf
  ],
  templateUrl: './popup.component.html',
  styleUrl: './popup.component.css'
})
export class PopupComponent implements AfterViewInit {
  @Input() visible = false;
  @Input() closeOnBackdrop = true; // close when clicking outside modal
  @Output() close = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    this.focusFirstInput();
  }

  ngOnChanges() {
    if (this.visible) {
      setTimeout(() => this.focusFirstInput(), 0);
    }
  }

  private focusFirstInput() {
    if (!this.visible) return;
    const input: HTMLElement | null = this.el.nativeElement.querySelector('input, textarea, button');
    if (input) input.focus();
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEsc(event: KeyboardEvent) {
    if (this.visible) this.close.emit();
  }

  backdropClick(event: MouseEvent) {
    if (this.closeOnBackdrop && event.target === event.currentTarget) {
      this.close.emit();
    }
  }
}
